import { DatePipe } from '@angular/common'
import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnDestroy,
  Output,
  ViewChild,
} from '@angular/core'
import { Observable } from 'rxjs'
import { Subscription } from 'rxjs/internal/Subscription'
import { AEMChunk } from 'src/app/services/AEM/aem-chunk.model'
import { ContentService } from 'src/app/services/content.service' 
import { CentralContentService } from 'src/app/services/content/central-content.service'
import { ContentLoadService } from 'src/app/services/content-load.service' 
import { LoadingService } from 'src/app/services/loading.service';
import { Constants } from 'src/assets/constants'
import { environment } from 'src/environments/environment'

import { Entity } from '../../../models/fund-details.model'

@Component({
  selector: 'VFA-detail-view',
  templateUrl: './detail-view.component.html',
  styleUrls: ['./detail-view.component.scss','../../../../assets/scss/tables.scss',]
})
export class DetailViewComponent implements OnDestroy {
  loading$: Observable<boolean>
  public priceAsOfDate: string
  @Input() data: Entity[]
  @Input() fullData: Entity[]
  @Input() comparedFunds: string[]
  @Input() pageNumber: number
  @Input() sortColumn: string
  @Input() sortDirection: string
  @Input() filterBy: string
  @Input() disableSwitch : boolean;
  @Input() openFilter:boolean
  @Input() closeFilters:boolean
  public days: string
  public tokens: string[]
  public token: any
  public annualReturnsDate: string
  public ytdAsOfDate: string
  public readonly secYieldPath = '/sec-yield'
  @Output() public changeResultsData: EventEmitter<any> = new EventEmitter<
    any
  >()
  noteTextAem: AEMChunk

  noteText=""
  isScrollableForWindowSize: boolean
  isScrollableForContent: boolean
  device: any
  switchModel: boolean;
  @ViewChild('detailedView') overviewTable: ElementRef<HTMLInputElement>

  // AEM content Vars
  price: AEMChunk
  unitPrice: AEMChunk
  investmentMinimum: AEMChunk
  advisedOnly: AEMChunk
  Comparisonoffunds: AEMChunk
  ExpenseContent: AEMChunk
  aemContentSub: Subscription
  secContent: AEMChunk
  public staticTicker: any[] = [
    'BNDX',
    'VTIP',
    'VIPSX',
    'VTAPX',
    'VGCIX',
    'VTABX',
    'VAIPX',
    'VIPIX',
    'VTSPX',
  ]
  public staticTickerMap: any = {}
  datePipe: DatePipe
  scrollBarPosition = 0
  showRightButton = false
  innerWidth: number

  // eslint-disable-next-line max-params
  constructor(
    private readonly centralContentService: CentralContentService,
    private readonly loadingService: LoadingService,
    private readonly loadContent: ContentLoadService,
    private readonly contentService: ContentService


  ) {
    this.datePipe = new DatePipe('en-US')
    this.loading$ = this.loadingService.loading$
  }

  public readonly profileRoot: string = environment.LegacyRoot
  public readonly vanguard529Profile: string = environment.investorUrl
  public dialogTitle = ''
  public investorURI: string
  public readonly etfPath = '/investment-products/etfs/profile/'
  public readonly mfPath = '/investment-products/mutual-funds/profile/'

  ngOnInit(): void {
    this.findScreenSize()
    this.sliceData()
    this.switchModel= false
    this.safariDetector()
    this.investorURI = environment.investorUrl
    this.aemContentSub = this.centralContentService.aemContent$.subscribe(
      (content) => {
        this.parseAEMContent(content)
      },
    )
    this.contentService.getContent().subscribe((response) => {
      this.loadContent.updateContent(response);
    })
  }
  parseAEMContent(content) {
    this.advisedOnly = this.centralContentService.getContentByBody(
      'configuration_vanguard_advised_only_icon',
      content,
    )
    this.Comparisonoffunds = this.centralContentService.getContentByBody(
      'fund_definitions_comparison_of_funds',
      content,
    )
    this.ExpenseContent = this.centralContentService.getContentByBody(
      'fund_definitions_expense_ratio',
      content,
    )
    this.advisedOnly = this.centralContentService.getContentByBody(
      'configuration_vanguard_advised_only_icon',
      content,
    )
    this.Comparisonoffunds = this.centralContentService.getContentByBody(
      'fund_definitions_comparison_of_funds',
      content,
    )
    this.advisedOnly = this.centralContentService.getContentByBody(
      'configuration_vanguard_advised_only_icon',
      content,
    )
    this.investmentMinimum = this.centralContentService.getContentByBody(
      'fund_definitions_whats_an_investment_minimum',
      content,
    )
    this.price = this.centralContentService.getContentByBody(
      'fund_definitions_price',
      content,
    )
    this.unitPrice = this.centralContentService.getContentByBody(
      'fund_definitions_unit_price',
      content,
    )
    this.Comparisonoffunds = this.centralContentService.getContentByBody(
      'fund_definitions_comparison_of_funds',
      content,
    )
    this.secContent = this.centralContentService.getContentByBody(
      'fund_definitions_yield',
      content,
    )
    this.staticTickerMap = {
      BNDX: this.centralContentService.getContentByBody(
        'fund_definitions_bndx',
        content,
      ),
      VTIP: this.centralContentService.getContentByBody(
        'fund_definitions_vtip',
        content,
      ),
      VIPSX: this.centralContentService.getContentByBody(
        'fund_definitions_vipsx',
        content,
      ),
      VTAPX: this.centralContentService.getContentByBody(
        'fund_definitions_vtapx',
        content,
      ),
      VGCIX: this.centralContentService.getContentByBody(
        'fund_definitions_vgcix',
        content,
      ),
      VTABX: this.centralContentService.getContentByBody(
        'fund_definitions_vtabx',
        content,
      ),
      VAIPX: this.centralContentService.getContentByBody(
        'fund_definitions_vaipx',
        content,
      ),
      VIPIX: this.centralContentService.getContentByBody(
        'fund_definitions_vipix',
        content,
      ),
      VTSPX: this.centralContentService.getContentByBody(
        'fund_definitions_vtspx',
        content,
      ),
    }
  }
  updateSortData(event) {
    this.sliceData()
    this.sortColumn = event.sortColumn
    this.sortDirection = event.sortDirection
    this.changeResultsData.emit(event)
  }

  changePriceToggle(event){
    if(event==='NAV'){
    this.switchModel=false;
    }else if(event==='Market'){
    this.switchModel=true;
    }
  }

  advisedBanner(fundId: string) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    if (
      this.advisedOnly !== undefined &&
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.advisedOnly.contentValue.indexOf(fundId) > -1
    ) {
      return true
    }
    return false
  }

  isNumber(val: any): boolean {
    return !isNaN(val)
  }
  ngOnChanges() {
    this.sliceData()
    this.onResize()
    this.findScreenSize()
  }

  sliceData() {
    this.data = this.fullData.slice(
      (this.pageNumber - 1) * Constants.PAGE_SIZE,
      this.pageNumber * Constants.PAGE_SIZE,
    )
    if (this.data.length > 0) {
      this.priceAsOfDate = this.data[0]?.dailyPrice?.regular?.asOfDate
      this.annualReturnsDate = this.data[0]?.monthEndAvgAnnualRtn?.asOfDate
      this.ytdAsOfDate = this.data[0]?.ytd?.asOfDate
      
      // eslint-disable-next-line complexity, max-statements
      this.data.forEach(data => {
        const priceAsOfDate = data?.dailyPrice?.regular?.asOfDate
        const ytdAsOfDate = data?.ytd?.asOfDate
        const annualReturnsDate = data?.monthEndAvgAnnualRtn?.asOfDate

        if (priceAsOfDate && !this.priceAsOfDate) {
          this.priceAsOfDate = priceAsOfDate
        }

        if (ytdAsOfDate && !this.ytdAsOfDate) {
          this.ytdAsOfDate = ytdAsOfDate
        }
        if (annualReturnsDate && !this.annualReturnsDate) {
          this.annualReturnsDate = annualReturnsDate
        }
    
      })
    }
    this.onResize()
  }
  emDashDisplay(value: any) {
    if (value !== null && value !== undefined) {
      return value
    }
    return '&#8212;'
  }
  ngOnDestroy(): void {
    this.aemContentSub.unsubscribe()
  }

  // eslint-disable-next-line complexity, max-statements
  public setDialogInfo(type = '', noteText = '', notecode = '') {
    this.dialogTitle = type
    const COMPARISON_OF_FUNDS = 'Comparison of funds'
    this.noteText = notecode.concat(' - ').concat(noteText)
    if (this.staticTickerMap[noteText]) {
      this.noteTextAem = this.staticTickerMap[noteText]
      this.noteText = this.noteTextAem.contentValue
    }
    if (this.dialogTitle === 'Expense ratio') {
      this.noteText = this.ExpenseContent.contentValue
    }
    if (this.dialogTitle === COMPARISON_OF_FUNDS) {
      this.noteText = this.Comparisonoffunds.contentValue
    }
    if (this.dialogTitle === 'SEC yield') {
      this.noteText = this.secContent.contentValue
    }
    if (this.dialogTitle === 'Investment Minimum') {
      this.noteText = this.investmentMinimum.contentValue
    }
    if (this.dialogTitle === 'Price') {
     const content = this.loadContent.content$.getValue();
     this.noteText = null != content ? content["@closingMarketPrice"] : this.price.contentValue;
   }
    if (this.dialogTitle === 'Unit Price') {
      this.noteText = this.unitPrice.contentValue
    }
  }

  // eslint-disable-next-line complexity
  public createDaysToken(yieldNote: any) {
    if (yieldNote !== undefined) {
      for (let i = 0; i < yieldNote.length; i++) {
        if (yieldNote[i].footnoteText !== undefined) {
          this.days = yieldNote[i].footnoteText
          this.tokens = this.days.split(' ')
          for (let j = 0; j < this.tokens.length; j++) {
            this.token = this.tokens[j].trim()
            if (!isNaN(this.token) && this.token.length > 0) {
              return this.token + ' day'
            }
          }
        }
      }
    }
  }

  formatLink(str) {
    const from = ['&lt;', '&gt;', '&amp;', '&quot;', '>nbsp;']
    const to = ['<', '>', '&', '"', ' ']
    from.forEach((data, index) => {
      str = this.regularExpression(str, data, to[index])
    })
    return str
  }
  regularExpression(str, find, replace) {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    const escapedFind = find.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
    return str.toString().replace(new RegExp(escapedFind, 'g'), replace)
  }

  @HostListener('window:resize')
  onResize() {
    setTimeout(
      () => {
        const { scrollWidth, offsetWidth } = this.overviewTable.nativeElement
        this.isScrollableForWindowSize = scrollWidth > offsetWidth
        this.isScrollableForContent = scrollWidth > offsetWidth
      }, // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      300,
    )
  }
  safariDetector() {
    this.device = navigator.userAgent
    if (
      this.device.indexOf('AppleWebKit') > 1 &&
      this.device.indexOf('Version/15.') > 1
    ) {
      document.documentElement.style.setProperty('--customTopFirst', '53px')
      document.documentElement.style.setProperty('--customTopSecond', '132px')
    }
  }

  moveRight() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.overviewTable.nativeElement.scrollLeft += 250
  }
  moveLeft() {
    // eslint-disable-next-line @typescript-eslint/no-magic-numbers
    this.overviewTable.nativeElement.scrollLeft -= 250
  }
  findScreenSize() {
    this.innerWidth = window.innerWidth
  }

  scrollTableHandler() {
    this.showRightButton =
      this.overviewTable.nativeElement.offsetWidth + this.overviewTable.nativeElement.scrollLeft >
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        this.overviewTable.nativeElement.scrollWidth - 1
        ? false
        : true
    this.scrollBarPosition = this.overviewTable.nativeElement.scrollLeft
  }
}
